import React from 'react';
import moment from 'moment/moment';

import { calculateWidth } from '../../tools';
import { CustomTimePicker } from '../../../../CustomTimePicker/CustomTimePicker';
import { useStyles } from '../../useStyles';

const DateField = ({ length, id, title, onFocus, required, onTimeChange, defaultValue }) => {
    const classes = useStyles();

    return (
        <div
            className={classes.container}
            style={{
                flexBasis: calculateWidth(length),
            }}
        >
            <CustomTimePicker
                name={id}
                label={title.toUpperCase()}
                placeholder={title.toUpperCase()}
                fullWidth={true}
                {...{ onFocus, required }}
                onChange={onTimeChange}
                style={{ width: '100%' }}
                value={defaultValue ? moment.utc(defaultValue) : null}
            />
        </div>
    );
};

export { DateField };
